import e from "./ghl-ui.es1506.js";
import o from "./ghl-ui.es1466.js";
function d(r) {
  o(1, arguments);
  var t = e(r), a = t.getDay();
  return a;
}
export {
  d as default
};
